<template>
  <div class="fees-card-background row">
    <div class="push-10-t">
      <div class="">
        <div class="text-left push-10 font-weight-bold">
          <img v-if="!disableIcons" src="/assets/img/check-mark-white.svg" class="push-10-r">
          <span>{{ ccPercentage }}% + $0.30 per credit card transaction</span>
        </div>

        <div class="text-left push-10 font-weight-bold">
          <img v-if="!disableIcons" src="/assets/img/check-mark-white.svg" class="push-10-r">
          <span>{{ achPercentage }}% per ACH transaction, minumum of $0.30</span>
        </div>

        <div class="text-left push-10 font-weight-bold" v-if="achFeeCap && achFeeCap > 0">
          <img v-if="!disableIcons" src="/assets/img/check-mark-white.svg" class="push-10-r">
          <span>Maximum fee of ${{ achFeeCap / 100 }} per ACH transaction</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Watch, Vue } from 'vue-facing-decorator'; 
import UserTypes from '../../../types/users';
import TransactionFeesMixin from '~/mixins/TransactionFees';

interface TransactionFees extends TransactionFeesMixin {}

@Component({mixins: [TransactionFeesMixin]})
class TransactionFees extends Vue {
  @Prop({ type: String }) coupon!: string;
  @Prop({ type: Object }) currentUser!: UserTypes.User;
  @Prop({ type: Boolean }) disableIcons!: boolean;

  feeWrapper: (Element | any)[] = [];

  async created() {
    await this.loadPlanFees(this.coupon);
  }

  @Watch('coupon')
  async couponChanged() {
    await this.loadPlanFees(this.coupon);
    if (this.couponValid) {
      this.flickerFees();
    }
  }

  flickerFees() {
    // Flicker the fee boxes to draw attention when they change
    const keyframes: Keyframe[] = [
      { opacity: '10%' },
      { opacity: '100%' }
    ];
    const timing = {
      duration: 500,
      iterations: 1
    };
    for (const el of this.feeWrapper) {
      el.animate(keyframes, timing);
    }
  }

  get achFeeCap() {
    return this.currentUser?.firm?.achFeeCap ? this.currentUser?.firm?.achFeeCap : this.pricing?.ACHFeeCap;
  }
}

export default TransactionFees;
</script>
